import { RootState } from 'store/rootReducer';

export const NoConnectionNotificationSelector = (state: RootState) => state.content.noConnectionNotification;
